<div [id]="mapId" [style.width]="width" [style.height.%]="100"></div>